



























































































import { Component, Vue } from 'vue-property-decorator';
import { AgencySettingsModule } from '@/store/modules/agencySettings'
import { AppModule } from '@/store/modules/app';
import SkillDto from '@/models/Skills/SkillDto'
import GiganautVue from '@/components/Shared/GiganautVue';
import SkillCreate from '@/components/Skills/SkillCreate.vue';
import SkillEdit from '@/components/Skills/SkillEdit.vue';

@Component({
  name: 'Skills',
  components: { SkillCreate, SkillEdit }
})
export default class extends GiganautVue {
    
    async beforeMount() {
        AgencySettingsModule.updateCurrentSkill(null);
    }

    async updateCurrentSkill(skill: SkillDto) {
        AgencySettingsModule.updateCurrentSkill(skill);
    }

    get currentSkill() {
        return AgencySettingsModule.currentSkill;
    }

    get loadingSkills() {
        return AgencySettingsModule.loadingSkills;
    }

    get skills() {
        return AgencySettingsModule.skills;
    }
}
